// app/javascript/utils/firebase/storage.js

import { app } from './initialise.js'; // Import the initialized Firebase app
import {
  getStorage,
  ref,
  uploadBytesResumable, // Modern way for uploads, includes progress tracking
  getDownloadURL,
  deleteObject
} from 'firebase/storage';

// Initialize Firebase Storage and associate it with your app
const storage = getStorage(app);

// Export the initialized storage instance AND common functions
// Exporting functions directly makes them easier to import elsewhere
export {
  storage,              // The storage service instance
  ref,                  // Function to create storage references
  uploadBytesResumable, // Function for resumable uploads
  getDownloadURL,       // Function to get the public URL of a file
  deleteObject          // Function to delete a file
  // Export other imported functions as needed
};

console.log("Firebase Storage initialized.");
